import { Obj3d } from './obj3d';
import { Varios3d } from './varios3d';
import { Scheme3dComponent } from './scheme3d.component';
import { Vector3, MeshPhongMaterial } from 'three';

export class Panels3d extends Obj3d {

	constructor(path: string, debug = false) {
		super(path, debug);

		// Añadir al archivo el campo = mongoDB 'rivisa.panels.altura'.
		// CLASSIC [0m60, 1m00, 1m50, 2m00] (4). ROOT -> (move x) abrazaderas; (scale x, adjust UV) barraSuperior, barraInferior, bastidor.
		// CLASSIC [1m00, 1m50, 2m00] (3). ROOT -> (move x) abrazaderas; (scale x, adjust UV) barraSuperior, barraInferior, bastidor.
		// La Verja RITMOCLIP y RITMO tienen el mismo bastidor, solo cambia el poste.
		this._data = {
			'LUX_EST_1m00': { estado: 0, archivo: 'BasLUXEst_1m00', carpeta: 'BasLUXEst', mesh: undefined, length: 3, uv: 1 },
			'LUX_EST_1m50': { estado: 0, archivo: 'BasLUXEst_1m50', carpeta: 'BasLUXEst', mesh: undefined, length: 3, uv: 1 },
			'LUX_EST_2m00': { estado: 0, archivo: 'BasLUXEst_2m00', carpeta: 'BasLUXEst', mesh: undefined, length: 3, uv: 1 },
			'LUX_EST_3m00': { estado: 0, archivo: 'BasLUXEst_3m00', carpeta: 'BasLUXEst', mesh: undefined, length: 3, uv: 1 },
			'LUX_EST_4m00': { estado: 0, archivo: 'BasLUXEst_4m00', carpeta: 'BasLUXEst', mesh: undefined, length: 3, uv: 1 },

			'LUX_ELECTRO_1m00': { estado: 0, archivo: 'BasLUXElectro_1m00', carpeta: 'BasLUXElectro', mesh: undefined, length: 3, uv: 1 },
			'LUX_ELECTRO_1m50': { estado: 0, archivo: 'BasLUXElectro_1m50', carpeta: 'BasLUXElectro', mesh: undefined, length: 3, uv: 1 },
			'LUX_ELECTRO_50_1m50': { estado: 0, archivo: 'BasLUXElectro_50_1m50', carpeta: 'BasLUXElectro', mesh: undefined, length: 3, uv: 1 },
			'LUX_ELECTRO_2m00': { estado: 0, archivo: 'BasLUXElectro_2m00', carpeta: 'BasLUXElectro', mesh: undefined, length: 3, uv: 1 },
			'LUX_ELECTRO_50_2m00': { estado: 0, archivo: 'BasLUXElectro_50_2m00', carpeta: 'BasLUXElectro', mesh: undefined, length: 3, uv: 1 },

			'LUX_ANUDADAInicial_1m00_15': { estado: 0, archivo: 'BasLUXAnudadaInicial_1m00_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADAInicial_1m00_30': { estado: 0, archivo: 'BasLUXAnudadaInicial_1m00_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACentro_1m00_15': { estado: 0, archivo: 'BasLUXAnudadaCentro_1m00_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACentro_1m00_30': { estado: 0, archivo: 'BasLUXAnudadaCentro_1m00_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACarracas_1m00_15': { estado: 0, archivo: 'BasLUXAnudadaCarracas_1m00_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACarracas_1m00_30': { estado: 0, archivo: 'BasLUXAnudadaCarracas_1m00_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },

			'LUX_ANUDADAInicial_1m50_15': { estado: 0, archivo: 'BasLUXAnudadaInicial_1m50_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADAInicial_1m50_30': { estado: 0, archivo: 'BasLUXAnudadaInicial_1m50_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACentro_1m50_15': { estado: 0, archivo: 'BasLUXAnudadaCentro_1m50_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACentro_1m50_30': { estado: 0, archivo: 'BasLUXAnudadaCentro_1m50_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACarracas_1m50_15': { estado: 0, archivo: 'BasLUXAnudadaCarracas_1m50_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACarracas_1m50_30': { estado: 0, archivo: 'BasLUXAnudadaCarracas_1m50_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },

			'LUX_ANUDADAInicial_2m00_15': { estado: 0, archivo: 'BasLUXAnudadaInicial_2m00_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADAInicial_2m00_30': { estado: 0, archivo: 'BasLUXAnudadaInicial_2m00_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACentro_2m00_15': { estado: 0, archivo: 'BasLUXAnudadaCentro_2m00_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACentro_2m00_30': { estado: 0, archivo: 'BasLUXAnudadaCentro_2m00_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACarracas_2m00_15': { estado: 0, archivo: 'BasLUXAnudadaCarracas_2m00_15', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },
			'LUX_ANUDADACarracas_2m00_30': { estado: 0, archivo: 'BasLUXAnudadaCarracas_2m00_30', carpeta: 'BasLUXAnudada', mesh: undefined, length: 0.9, uv: 1 },

			'BRICO-FAX_1m00': { estado: 0, archivo: 'BasBricoFax_1m00', carpeta: 'BasBricoFax', mesh: undefined, length: 2.53, uv: 1.536 },
			'BRICO-FAX_1m50': { estado: 0, archivo: 'BasBricoFax_1m50', carpeta: 'BasBricoFax', mesh: undefined, length: 2.53, uv: 1.536 },
			'BRICO-FAX_2m00': { estado: 0, archivo: 'BasBricoFax_2m00', carpeta: 'BasBricoFax', mesh: undefined, length: 2.53, uv: 1.536 },

			'FAX_0m60': { estado: 0, archivo: 'BasFAX_0m60', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 4.212 },
			'FAX_1m00': { estado: 0, archivo: 'BasFAX_1m00', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.499 },
			'FAX_1m20': { estado: 0, archivo: 'BasFAX_1m20', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.499 },

			'FAX_1m43': { estado: 0, archivo: 'BasFAX_1m50_LUX50_2puntas', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.499 },

			'FAX_1m50': { estado: 0, archivo: 'BasFAX_1m50', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.499 },
			'FAX_1m51': { estado: 0, archivo: 'BasFAX_1m50', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.499 },

			'FAX_1m80': { estado: 0, archivo: 'BasFAX_1m80', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 1.241 },

			'FAX_2m00': { estado: 0, archivo: 'BasFAX_2m00', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 1.241 },
			'FAX_2m03': { estado: 0, archivo: 'BasFAX_2m00_LUX80_4puntas', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.0 },
			'FAX_2m40': { estado: 0, archivo: 'BasFAX_2m40_LUX80_4puntas', carpeta: 'BasFAX', mesh: undefined, length: 2.53, uv: 2.0 },	
			


			// 'FAX_0m60_CUADRADO': { estado: 0, archivo: 'BasFAX_0m60_CUADRADO', carpeta: 'BasFAX', mesh: undefined, length: 2.495, uv: 4.212 },
			// 'FAX_1m00_CUADRADO': { estado: 0, archivo: 'BasFAX_1m00_CUADRADO', carpeta: 'BasFAX', mesh: undefined, length: 2.495, uv: 2.499 },
			// 'FAX_1m20_CUADRADO': { estado: 0, archivo: 'BasFAX_1m20_CUADRADO', carpeta: 'BasFAX', mesh: undefined, length: 2.495, uv: 2.499 },
			// 'FAX_1m50_CUADRADO': { estado: 0, archivo: 'BasFAX_1m50_CUADRADO', carpeta: 'BasFAX', mesh: undefined, length: 2.495, uv: 2.499 },
			// 'FAX_1m80_CUADRADO': { estado: 0, archivo: 'BasFAX_1m80_CUADRADO', carpeta: 'BasFAX', mesh: undefined, length: 2.495, uv: 1.241 },
			// 'FAX_2m00_CUADRADO': { estado: 0, archivo: 'BasFAX_2m00_CUADRADO', carpeta: 'BasFAX', mesh: undefined, length: 2.495, uv: 1.241 },


			'FAX DH_1m00': { estado: 0, archivo: 'BasFaxDH_1m00', carpeta: 'BasFaxDH', mesh: undefined, length: 2.53, uv: 2.712 },
			'FAX DH_1m20': { estado: 0, archivo: 'BasFaxDH_1m20', carpeta: 'BasFaxDH', mesh: undefined, length: 2.53, uv: 2.712 },
			'FAX DH_1m40': { estado: 0, archivo: 'BasFaxDH_1m40', carpeta: 'BasFaxDH', mesh: undefined, length: 2.53, uv: 2.712 },
			'FAX DH_1m60': { estado: 0, archivo: 'BasFaxDH_1m60', carpeta: 'BasFaxDH', mesh: undefined, length: 2.53, uv: 2.712 },
			'FAX DH_1m80': { estado: 0, archivo: 'BasFaxDH_1m80', carpeta: 'BasFaxDH', mesh: undefined, length: 2.53, uv: 2.712 },
			'FAX DH_2m00': { estado: 0, archivo: 'BasFaxDH_2m00', carpeta: 'BasFaxDH', mesh: undefined, length: 2.53, uv: 2.712 },

			'MAXI-FAX_1m50': { estado: 0, archivo: 'BasMaxiFax_1m50', carpeta: 'BasMaxiFax', mesh: undefined, length: 2.64, uv: 0.707 },
			'MAXI-FAX_2m00': { estado: 0, archivo: 'BasMaxiFax_2m00', carpeta: 'BasMaxiFax', mesh: undefined, length: 2.64, uv: 1 },
			'MAXI-FAX_2m40': { estado: 0, archivo: 'BasMaxiFax_2m40', carpeta: 'BasMaxiFax', mesh: undefined, length: 2.64, uv: 1 },

			'RITMO_0m60': { estado: 0, archivo: 'BasRitmo_0m60', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2.618 },
			'RITMO_0m80': { estado: 0, archivo: 'BasRitmo_0m80', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m00': { estado: 0, archivo: 'BasRitmo_1m00', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m01': { estado: 0, archivo: 'BasRitmo_1m00', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m20': { estado: 0, archivo: 'BasRitmo_1m20', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m21': { estado: 0, archivo: 'BasRitmo_1m20', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },

			'RITMO_1m43': { estado: 0, archivo: 'BasRitmo_1m50_2puntas', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m50': { estado: 0, archivo: 'BasRitmo_1m50', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m51': { estado: 0, archivo: 'BasRitmo_1m50', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },


			'RITMO_1m80': { estado: 0, archivo: 'BasRitmo_1m80', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_1m81': { estado: 0, archivo: 'BasRitmo_1m80', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },

			'RITMO_2m00': { estado: 0, archivo: 'BasRitmo_2m00', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },
			'RITMO_2m01': { estado: 0, archivo: 'BasRitmo_2m00', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },

			'RITMO_2m03': { estado: 0, archivo: 'BasRitmo_2m00_4puntas', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },

			'RITMO_2m40': { estado: 0, archivo: 'BasRitmo_2m40', carpeta: 'BasRitmo', mesh: undefined, length: 2.53, uv: 2 },


			// 'RITMO_0m60_CUADRADO': { estado: 0, archivo: 'BasRitmo_0m60_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2.618 },
			// 'RITMO_0m80_CUADRADO': { estado: 0, archivo: 'BasRitmo_0m80_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },
			// 'RITMO_1m00_CUADRADO': { estado: 0, archivo: 'BasRitmo_1m00_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },
			// 'RITMO_1m20_CUADRADO': { estado: 0, archivo: 'BasRitmo_1m20_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },
			// 'RITMO_1m50_CUADRADO': { estado: 0, archivo: 'BasRitmo_1m50_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },
			// 'RITMO_1m80_CUADRADO': { estado: 0, archivo: 'BasRitmo_1m80_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },
			// 'RITMO_2m00_CUADRADO': { estado: 0, archivo: 'BasRitmo_2m00_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },
			// 'RITMO_2m40_CUADRADO': { estado: 0, archivo: 'BasRitmo_2m40_CUADRADO', carpeta: 'BasRitmo', mesh: undefined, length: 2.495, uv: 2 },

			'RITMO DH_1m00': { estado: 0, archivo: 'BasRitmoDH_1m00', carpeta: 'BasRitmoDH', mesh: undefined, length: 2.53, uv: 2.7 },
			'RITMO DH_1m20': { estado: 0, archivo: 'BasRitmoDH_1m20', carpeta: 'BasRitmoDH', mesh: undefined, length: 2.53, uv: 2.7 },
			'RITMO DH_1m40': { estado: 0, archivo: 'BasRitmoDH_1m40', carpeta: 'BasRitmoDH', mesh: undefined, length: 2.53, uv: 2.7 },
			'RITMO DH_1m60': { estado: 0, archivo: 'BasRitmoDH_1m60', carpeta: 'BasRitmoDH', mesh: undefined, length: 2.53, uv: 2.7 },
			'RITMO DH_1m80': { estado: 0, archivo: 'BasRitmoDH_1m80', carpeta: 'BasRitmoDH', mesh: undefined, length: 2.53, uv: 2.7 },
			'RITMO DH_2m00': { estado: 0, archivo: 'BasRitmoDH_2m00', carpeta: 'BasRitmoDH', mesh: undefined, length: 2.53, uv: 2.7 },

			'RITMOCLIP_0m60': { estado: 0, archivo: 'BasRitmo_0m60', carpeta: 'BasRitmo', mesh: undefined, length: 2.504, uv: 2 },
			'RITMOCLIP_1m00': { estado: 0, archivo: 'BasRitmo_1m00', carpeta: 'BasRitmo', mesh: undefined, length: 2.504, uv: 2 },
			'RITMOCLIP_1m20': { estado: 0, archivo: 'BasRitmo_1m20', carpeta: 'BasRitmo', mesh: undefined, length: 2.504, uv: 2 },
			'RITMOCLIP_1m50': { estado: 0, archivo: 'BasRitmo_1m50', carpeta: 'BasRitmo', mesh: undefined, length: 2.504, uv: 2 },
			'RITMOCLIP_1m80': { estado: 0, archivo: 'BasRitmo_1m80', carpeta: 'BasRitmo', mesh: undefined, length: 2.504, uv: 2 },
			'RITMOCLIP_2m00': { estado: 0, archivo: 'BasRitmo_2m00', carpeta: 'BasRitmo', mesh: undefined, length: 2.504, uv: 2 },

			'CALITAX_1m00': { estado: 0, archivo: 'BasCalitax_1m00', carpeta: 'BasCalitax', mesh: undefined, length: 2.835, uv: 2.75 },
			'CALITAX_1m20': { estado: 0, archivo: 'BasCalitax_1m20', carpeta: 'BasCalitax', mesh: undefined, length: 2.835, uv: 2.75 },
			'CALITAX_1m50': { estado: 0, archivo: 'BasCalitax_1m50', carpeta: 'BasCalitax', mesh: undefined, length: 2.835, uv: 2.75 },
			'CALITAX_1m80': { estado: 0, archivo: 'BasCalitax_1m80', carpeta: 'BasCalitax', mesh: undefined, length: 2.835, uv: 2.75 },
			'CALITAX_2m00': { estado: 0, archivo: 'BasCalitax_2m00', carpeta: 'BasCalitax', mesh: undefined, length: 2.835, uv: 2.75 },


			'CALITAX_1m00_CUADRADO': { estado: 0, archivo: 'BasCalitax_1m00_CUADRADO', carpeta: 'BasCalitax', mesh: undefined, length: 2.815, uv: 2.75 },
			'CALITAX_1m20_CUADRADO': { estado: 0, archivo: 'BasCalitax_1m20_CUADRADO', carpeta: 'BasCalitax', mesh: undefined, length: 2.815, uv: 2.75 },
			'CALITAX_1m50_CUADRADO': { estado: 0, archivo: 'BasCalitax_1m50_CUADRADO', carpeta: 'BasCalitax', mesh: undefined, length: 2.815, uv: 2.75 },
			'CALITAX_1m80_CUADRADO': { estado: 0, archivo: 'BasCalitax_1m80_CUADRADO', carpeta: 'BasCalitax', mesh: undefined, length: 2.815, uv: 2.75 },
			'CALITAX_2m00_CUADRADO': { estado: 0, archivo: 'BasCalitax_2m00_CUADRADO', carpeta: 'BasCalitax', mesh: undefined, length: 2.815, uv: 2.75 },


			'CLASSIC_0m60': { estado: 0, archivo: 'BasClassic_0m60', carpeta: 'BasClassic', mesh: undefined, length: 2.835, uv: 2.75 },
			'CLASSIC_1m00': { estado: 0, archivo: 'BasClassic_1m00', carpeta: 'BasClassic', mesh: undefined, length: 2.835, uv: 2.75 },
			'CLASSIC_1m50': { estado: 0, archivo: 'BasClassic_1m50', carpeta: 'BasClassic', mesh: undefined, length: 2.835, uv: 2.75 },
			'CLASSIC_2m00': { estado: 0, archivo: 'BasClassic_2m00', carpeta: 'BasClassic', mesh: undefined, length: 2.835, uv: 2.75 },

			'DECOR_0m60': { estado: 0, archivo: 'BasDecor_0m60', carpeta: 'BasDecor', mesh: undefined, length: 2.835, uv: 4.025 },
			'DECOR_1m00': { estado: 0, archivo: 'BasDecor_1m00', carpeta: 'BasDecor', mesh: undefined, length: 2.835, uv: 4.025 },
			'DECOR_1m50': { estado: 0, archivo: 'BasDecor_1m50', carpeta: 'BasDecor', mesh: undefined, length: 2.835, uv: 4.025 },
			'DECOR_2m00': { estado: 0, archivo: 'BasDecor_2m00', carpeta: 'BasDecor', mesh: undefined, length: 2.835, uv: 4.025 },

			'DECOR_0m60_CUADRADO':{estado: 0, archivo: 'BasDecor_0m60_CUADRADO', carpeta: 'BasDecor', mesh: undefined, length: 2.815, uv: 6},
			'DECOR_1m00_CUADRADO': { estado: 0, archivo: 'BasDecor_1m00_CUADRADO', carpeta: 'BasDecor', mesh: undefined, length: 2.815, uv: 4.025 },
			'DECOR_1m50_CUADRADO': { estado: 0, archivo: 'BasDecor_1m50_CUADRADO', carpeta: 'BasDecor', mesh: undefined, length: 2.815, uv: 4.025 },
			'DECOR_2m00_CUADRADO': { estado: 0, archivo: 'BasDecor_2m00_CUADRADO', carpeta: 'BasDecor', mesh: undefined, length: 2.815, uv: 4.025 },


			'NATURE_1m00': { estado: 0, archivo: 'BasNature_1m00', carpeta: 'BasNature', mesh: undefined, length: 2.57, uv: 1 },
			'NATURE_1m20': { estado: 0, archivo: 'BasNature_1m20', carpeta: 'BasNature', mesh: undefined, length: 2.57, uv: 1 },
			'NATURE_1m50': { estado: 0, archivo: 'BasNature_1m50', carpeta: 'BasNature', mesh: undefined, length: 2.57, uv: 1 },
			'NATURE_1m80': { estado: 0, archivo: 'BasNature_1m80', carpeta: 'BasNature', mesh: undefined, length: 2.57, uv: 1 },
			'NATURE_2m00': { estado: 0, archivo: 'BasNature_2m00', carpeta: 'BasNature', mesh: undefined, length: 2.57, uv: 1 },
			'NATURE_2m40': { estado: 0, archivo: 'BasNature_2m40', carpeta: 'BasNature', mesh: undefined, length: 2.57, uv: 1 },

			'NATURE_1m00_CUADRADO': { estado: 0, archivo: 'BasNature_1m00_CUADRADO', carpeta: 'BasNature', mesh: undefined, length: 2.545, uv: 1 },
			'NATURE_1m20_CUADRADO': { estado: 0, archivo: 'BasNature_1m20_CUADRADO', carpeta: 'BasNature', mesh: undefined, length: 2.545, uv: 1 },
			'NATURE_1m50_CUADRADO': { estado: 0, archivo: 'BasNature_1m50_CUADRADO', carpeta: 'BasNature', mesh: undefined, length: 2.545, uv: 1 },
			'NATURE_1m80_CUADRADO': { estado: 0, archivo: 'BasNature_1m80_CUADRADO', carpeta: 'BasNature', mesh: undefined, length: 2.545, uv: 1 },
			'NATURE_2m00_CUADRADO': { estado: 0, archivo: 'BasNature_2m00_CUADRADO', carpeta: 'BasNature', mesh: undefined, length: 2.545, uv: 1 },
			'NATURE_2m40_CUADRADO': { estado: 0, archivo: 'BasNature_2m40_CUADRADO', carpeta: 'BasNature', mesh: undefined, length: 2.545, uv: 1 },

			'NOVE_0m60': { estado: 0, archivo: 'BasNove_0m60', carpeta: 'BasNove', mesh: undefined, length: 2.565, uv: 4.347 },
			'NOVE_1m00': { estado: 0, archivo: 'BasNove_1m00', carpeta: 'BasNove', mesh: undefined, length: 2.565, uv: 3.009 },
			'NOVE_1m20': { estado: 0, archivo: 'BasNove_1m20', carpeta: 'BasNove', mesh: undefined, length: 2.565, uv: 4.106  },
			'NOVE_1m50': { estado: 0, archivo: 'BasNove_1m50', carpeta: 'BasNove', mesh: undefined, length: 2.565, uv: 3.442 },

			'NOVE_0m60_CUADRADO': { estado: 0, archivo: 'BasNove_0m60_CUADRADO', carpeta: 'BasNove', mesh: undefined, length: 2.55, uv: 4.347 },
			'NOVE_1m00_CUADRADO': { estado: 0, archivo: 'BasNove_1m00_CUADRADO', carpeta: 'BasNove', mesh: undefined, length: 2.55, uv: 3.009 },
			'NOVE_1m20_CUADRADO': { estado: 0, archivo: 'BasNove_1m20_CUADRADO', carpeta: 'BasNove', mesh: undefined, length: 2.55, uv: 4.106 },
			'NOVE_1m50_CUADRADO': { estado: 0, archivo: 'BasNove_1m50_CUADRADO', carpeta: 'BasNove', mesh: undefined, length: 2.55, uv: 3.442 },


			'ULTRA_1m00': { estado: 0, archivo: 'BasUltra_1m00', carpeta: 'BasUltra', mesh: undefined, length: 2.835, uv: 2.75 },
			'ULTRA_1m20': { estado: 0, archivo: 'BasUltra_1m20', carpeta: 'BasUltra', mesh: undefined, length: 2.835, uv: 2.75 },
			'ULTRA_1m50': { estado: 0, archivo: 'BasUltra_1m50', carpeta: 'BasUltra', mesh: undefined, length: 2.835, uv: 2.75 },
			'ULTRA_1m80': { estado: 0, archivo: 'BasUltra_1m80', carpeta: 'BasUltra', mesh: undefined, length: 2.835, uv: 2.75 },
			'ULTRA_2m00': { estado: 0, archivo: 'BasUltra_2m00', carpeta: 'BasUltra', mesh: undefined, length: 2.835, uv: 2.75 },

			'ULTRA_1m00_CUADRADO': { estado: 0, archivo: 'BasUltra_1m00_CUADRADO', carpeta: 'BasUltra', mesh: undefined, length: 2.815, uv: 2.75 },
			'ULTRA_1m20_CUADRADO': { estado: 0, archivo: 'BasUltra_1m20_CUADRADO', carpeta: 'BasUltra', mesh: undefined, length: 2.815, uv: 2.75 },
			'ULTRA_1m50_CUADRADO': { estado: 0, archivo: 'BasUltra_1m50_CUADRADO', carpeta: 'BasUltra', mesh: undefined, length: 2.815, uv: 2.75 },
			'ULTRA_1m80_CUADRADO': { estado: 0, archivo: 'BasUltra_1m80_CUADRADO', carpeta: 'BasUltra', mesh: undefined, length: 2.815, uv: 2.75 },
			'ULTRA_2m00_CUADRADO': { estado: 0, archivo: 'BasUltra_2m00_CUADRADO', carpeta: 'BasUltra', mesh: undefined, length: 2.815, uv: 2.75 }
		};
	}

	// Calcula las divisiones de una sección, teniendo en cuenta si el resto es menor del 30% se debe equilibrar.
	// Si es menor 0 igual al 30% crear poste inicial cortado, relleno y final cortado.

	private RAD180 = 3.141592653589793;

	//#######################################################################################################################################
	private LENGTH_LUX_ANUDADA = 60 - 0.15; // Total quitando la carraca central.

	// Estira una malla LUX, método especial ya que usa varios bastidores y condiciones distintas a las otras LUX.
	// 1.- Se inicia siempre con carracas sin margen.
	// 2.- Se despliega la malla sin importar los angulos, solo se reinicia un inicio si se llego a una puerta o cambio de nivel.
	// 3.- Cada 60 metros se debe colocar carracas y seguir el mismo porceso anterior.
	// 4.- El poste con tornapuntas se coloca a 56 metros pero las carracas quedan a 60 metros.
	//		Medidas horizontales:	Inicio	centro	carracas	Inicio+centro
	//		De 15cm				:	15cm	5.55cm	30cm		5.70cm
	//		De 30cm				:	30cm	5.10cm	60cm		5.40cm
	public dividerLUXAnudada(
		scheme3d: Scheme3dComponent,	//	Creador del mundo.
		section: any,					//	Sección de un tramo.
		magnitud: number				//	Longitud de la sección.
	) {

		// Evitar undefineds.
		if (!section) return;

		// Tipo de malla 15 o 30. Puntero a los datos del bastidor.
		let aux = scheme3d.DTPerimeterActual.mesh.substr(-7);
		let bastidorInicial = this._data['LUX_ANUDADAInicial_' + aux];
		let bastidorCentro = this._data['LUX_ANUDADACentro_' + aux];
		let bastidorCarraca = this._data['LUX_ANUDADACarracas_' + aux];
		if (!bastidorInicial || !bastidorInicial.mesh || !bastidorCentro || !bastidorCentro.mesh || !bastidorCarraca || !bastidorCarraca.mesh) return;

		// Obtener el ancho a rellenar teniendo en cuenta los ajustes de desplazamiento de los postes.
		let length = section.magnitud - (section.marginA + section.marginB);

		// Punto X de inicio.
		let dotX = magnitud + section.marginA;

		// Cantidad de postes intermedios. let unidades = Math.floor(ancho / 6);

		// Altura del poste teniendo en cuenta los escalones.
		let alturaPoste = (-5 + scheme3d.DTPerimeterActual.heightPost) + section.height;

		// Altura de los tornapuntas dependiendo de la altura del muro y poste.
		let alturaTornaPuntas = ((scheme3d.DTPerimeterActual.heightPost / 100) * 75) + section.height;

		//#################################################################################
		//########## Nuevos calculos para el equilibrio de los postes centrales. ##########
		let div = Math.floor(length / scheme3d.DTPerimeterActual.separation);
		let margenEnd = length % scheme3d.DTPerimeterActual.separation;
		let margenStart = scheme3d.DTPerimeterActual.separation;

		// En caso de que el resto sea un 30% más pequeño que la medida del malla => distribuir.
		if ((margenEnd / 0.06) < 30) { // 0.06 (6 metros/100) Anudada postes 6 metros distancia.
			margenStart = (margenStart + margenEnd) / 2;
			margenEnd = margenStart;
		}

		// Poner postes.
		let inicioDraw = margenStart;
		let inicioRect = 0; // Contador de postes hasta colocar el poste con tornapuntas (10).
		if (div > 9) {
			let rx = ((div - 1) - ((Math.floor(div / 10) - 1) * 10));
			inicioRect = Math.floor(rx / 2);
			if ((rx % 2) !== 0) inicioRect++;
			inicioRect = 10 - (inicioRect + 1);
		}
		if (inicioRect === 0) inicioRect = 1;
		//########## Nuevos calculos para el equilibrio de los postes centrales. ##########
		//#################################################################################
		// Tener en cuenta si se pone poste.
		if (div > 0) {
			for (let p = 0; p < div; p++) {
				// Colocar poste.
				let _post = scheme3d.gestor.postes.clonePost(scheme3d.DTPerimeterActual.typePost, 'SubPoste' + scheme3d.DTNamePerTramo + scheme3d.DTCountPost++,
					inicioDraw + magnitud, alturaPoste, scheme3d.DTPerimeterActual.direction);
				if (_post) {
					// Pintar poste. if (scheme3d.DTHasColor) scheme3d.paintPost(_post);

					scheme3d.DTRootTramo.add(_post);
				}
				// Comprobar si hay que poner poste con tornapuntas
				if (inicioRect == 10) {
					inicioRect = 0;
					let tor = scheme3d.gestor.varios.clone(Varios3d.TornaPuntasRectoG);
					tor.name = 'tornapuntasRecto_' + scheme3d.DTNamePerTramo + scheme3d.DTCountTornaPuntas++;
					tor.position.x = _post.position.x;
					tor.position.y = alturaTornaPuntas;
					tor.scale.z = -scheme3d.DTPerimeterActual.direction;
					scheme3d.DTRootTramo.add(tor);

				}

				// Colocar placabase si es necesario.
				if (scheme3d.DTPerimeterActual.basePlaque) scheme3d.setPlacaBase(_post.position.x, section.height);
				inicioDraw += 6;
				inicioRect++;
			}
		}

		// Estirar la malla, existen multiples bastidores por ello hay que estirar tramos hasta finalizar el ancho.
		while (length > 0) {
			if (scheme3d.DTMetersLUXAnudada == 0) {	// *** Se inicia un nuevo bastidor.
				if (length < bastidorInicial.length) { // En caso de que el inicio sea mayor al ancho a cubrir, cortar bastidor.
					scheme3d.DTRootTramo.add(this.cloneEspecialAnudada(bastidorInicial, dotX, section.height, length, scheme3d.DTPerimeterActual.direction));
					return;	// Finaliza el tramo.
				}
				else { // Colocar el bastidor entero.
					scheme3d.DTRootTramo.add(this.cloneAllAnudada(bastidorInicial, dotX, section.height, scheme3d.DTPerimeterActual.direction));
					// Se reinicia colocar bastidor central.
					scheme3d.DTMetersLUXAnudada = bastidorInicial.length;	// Almacena la longitud total consumida, cuando llegue al máximo colocar carracas.
					dotX += bastidorInicial.length;		// Avanzar punto de inicio.
					length -= bastidorInicial.length;	// Restar ancho ya consumido.
				}
			}

			// Comprobar si se sigue dibujando.
			if (length > 0) {
				// Tener en cuenta si hay que poner bastidor central o bastidor carracas.
				if (scheme3d.DTMetersLUXAnudada >= this.LENGTH_LUX_ANUDADA) {
					if (length < bastidorCarraca.length) { // En caso de que el inicio sea mayor al ancho a cubrir, cortar bastidor.
						scheme3d.DTRootTramo.add(this.cloneEspecialAnudada(bastidorCarraca, dotX, section.height, length, scheme3d.DTPerimeterActual.direction));
						scheme3d.DTMetersLUXAnudada = length - 0.15; 		// Se reinicia colocar bastidor inicial.
						return; // Finaliza el tramo.
					}
					else { // Colocar el bastidor entero.
						scheme3d.DTRootTramo.add(this.cloneAllAnudada(bastidorCarraca, dotX, section.height, scheme3d.DTPerimeterActual.direction));
						// Se reinicia colocar bastidor central.
						scheme3d.DTMetersLUXAnudada = bastidorCarraca.length - 0.15;
						dotX += bastidorCarraca.length;		// Avanzar punto de inicio.
						length -= bastidorCarraca.length;	// Restar ancho ya consumido.
					}
				}
				// Colocar bastidor central.
				else {
					// Calcular lo que falta para rellenar un tramo normal.
					let falta = this.LENGTH_LUX_ANUDADA - scheme3d.DTMetersLUXAnudada; // Tener en cuetna el inicio.

					if (falta > 0) {
						// Calcular el longitud a colocar.
						falta = (falta > length) ? length : falta;
						scheme3d.DTRootTramo.add(this.cloneEspecialAnudada(bastidorCentro, dotX, section.height, falta, scheme3d.DTPerimeterActual.direction));

						scheme3d.DTMetersLUXAnudada += falta;
						dotX += falta;		// Avanzar punto de inicio.
						length -= falta;		// Restar ancho ya consumido.
					}
					else {
						length = 0;
					}
				}
			}
		}

		return;
	}

	//#######################################################################################################################################
	// Estira una malla LUX.
	// scheme3d			Creador del mundo.
	// section			Sección de una tramo.
	// magnitud			Longitud de la sección.
	public dividerLUX(scheme3d: Scheme3dComponent, section, magnitud) {
		
		// Evitar undefineds.
		if (!section) return;

		// Puntero a los datos del bastidor.
		let bastidor = this._data[scheme3d.DTPerimeterActual.mesh];
		
		if (!bastidor || !bastidor.mesh) return;

		// Obtener el ancho a rellenar teniendo en cuenta los ajustes de desplazamiento de los postes.
		let length = section.magnitud - (section.marginA + section.marginB);
		// console.log("SECTION.MAGNITUD");
		// console.log(section.magnitud)

		// Punto X de inicio. let dotX = magnitud + section.marginA;

		// Altura del poste teniendo en cuenta los esclones.
		let alturaPoste = (-5 + scheme3d.DTPerimeterActual.heightPost) + section.height;

		// Altura de los tornapuntas dependiendo de la altura del muro y poste.
		let alturaTornaPuntas = ((scheme3d.DTPerimeterActual.heightPost / 100) * 75) + section.height;

		let contadorTornaPuntas = 0;

		let matNeutro = (scheme3d.DTHasColor) ? scheme3d.gestor.ColorNeutro : undefined;

		//#################################################################################
		//########## Nuevos calculos para el equilibrio de los postes centrales. ##########
		// Unidad divisoría de la malla.
		let unidad = scheme3d.DTPerimeterActual.separation / 100;


		let div = Math.floor(length / scheme3d.DTPerimeterActual.separation);
		let margenEnd = length % scheme3d.DTPerimeterActual.separation;
		let margenStart = scheme3d.DTPerimeterActual.separation;

		// En caso de que el resto sea un 30% más pequeño que la medida del malla => distribuir.
		if ((margenEnd / unidad) < 30) {
			margenStart = (margenStart + margenEnd) / 2;
			margenEnd = margenStart;
		}

		// Poner postes.
		let inicioDraw = margenStart;
		let inicioRect = 0; // Contador de postes hasta colocar el poste con tornapuntas (10).
		
		if (div > 9) {
			let rx = ((div - 1) - ((Math.floor(div / 10) - 1) * 10));
			inicioRect = Math.floor(rx / 2);
			if ((rx % 2) !== 0) inicioRect++;
			inicioRect = 10 - (inicioRect + 1);
		}
		else {
			inicioRect = 1;
		}
		//########## Nuevos calculos para el equilibrio de los postes centrales. ##########
		//#################################################################################
		// Tener en cuenta si se pone poste.
		if (div > 0) {
			for (let p = 0; p < div; p++) {
				// Colocar poste.
				let _post = scheme3d.gestor.postes.clonePost(scheme3d.DTPerimeterActual.typePost, 'SubPoste' + scheme3d.DTNamePerTramo + scheme3d.DTCountPost++,
					inicioDraw + magnitud, alturaPoste, scheme3d.DTPerimeterActual.direction);
				if (_post) {
					// Pintar poste.
					if (scheme3d.DTHasColor) scheme3d.paintPost(_post);
					
					scheme3d.DTRootTramo.add(_post);
					
				}

				// Comprobar si hay que poner poste con soportes.
				if (inicioRect === 10) {
					inicioRect = 0;
					const colorTornapuntas = (scheme3d.DTHasColor) ? Varios3d.TornaPuntasRecto : Varios3d.TornaPuntasRectoG;
					let tor = scheme3d.gestor.varios.clone(colorTornapuntas);
					tor.name = 'tornapuntasRecto_' + scheme3d.DTNamePerTramo + contadorTornaPuntas++;
					tor.position.x = _post.position.x;
					tor.position.y = alturaTornaPuntas;
					tor.scale.z = -scheme3d.DTPerimeterActual.direction;

					// Color.
					if (scheme3d.DTHasColor) {
						for (let i = 0; i < tor.children.length; i++) {
							tor.children[i].material = scheme3d.gestor.ColorNeutro;
						}
					}
					scheme3d.DTRootTramo.add(tor);
				}

				// Colocar placabase si es necesario.
				if (scheme3d.DTPerimeterActual.basePlaque) scheme3d.setPlacaBase(_post.position.x, section.height);

				inicioDraw += 3;
				inicioRect++;
			}

		}

					// Estirar la malla.
		let bas = this.cloneEspecial(scheme3d.DTPerimeterActual.mesh, length, scheme3d.DTPerimeterActual.direction, 1, matNeutro, scheme3d);
		bas.position.x =magnitud;
		// console.log(bas.position.x);
		bas.position.y = section.height;
		scheme3d.DTRootTramo.add(bas);

		return;
	}

	//#######################################################################################################################################
	// Rellena una sección, devuelve la cantidad de bastidores colocados. Retorna la cantidad de postes colocados.
	// scheme3d					Creador del mundo.
	// section					Sección de un tramo.
	// magnitud					Longitud de la sección.
	public divider(scheme3d: Scheme3dComponent, section: any, magnitud: number) {
		// Evitar undefineds.
		if (!section) return;
		// console.log("section")
		// console.log(section)
		// Puntero a los datos del bastidor.
		let bastidor = this._data[scheme3d.DTPerimeterActual.mesh];

		if (!bastidor || !bastidor.mesh) return;

		// Obtener el ancho a rellenar teniendo en cuenta los ajustes de desplazamiento de los postes.
		let ancho = section.magnitud - (section.marginA + section.marginB);

		// si tiene poste doble, section.magnitud & Ancho, = 0.0848
		// Punto X de inicio.
		
		let dotX = magnitud + section.marginA;

		// Cantidad de bastidores enteros.
		let unidades = Math.floor(ancho / bastidor.length);


		// Bastidor cortado, se coloca después del bucle.
		let resto = parseFloat((ancho % bastidor.length).toFixed(4));

		if (resto == Infinity) resto = 0;

		// Pasar el resto al % según bastidor.
		let restoPorCiento = (resto / bastidor.length);


		let matNeutro = (scheme3d.DTHasColor) ? scheme3d.gestor.ColorNeutro : undefined;

		// ###################################################### Más de un bastidor.
		if (ancho > bastidor.length) {
			let alturaPoste = (-5 + scheme3d.DTPerimeterActual.heightPost) + section.height;

			// Tener en cuenta si el resto es igual o menos al 30% hacer equilibrado.
			if (resto > 0) { // Si es cero no hace falta cortar.

				// El corte de un bastidor no debe ser menor del 30% del mismo.
				if (restoPorCiento <= 0.3) {
					// Doble corte, se corta el inicial y el último proporcionalmente.
					resto = (bastidor.length + resto) / 2;
					restoPorCiento = (resto / bastidor.length);


					// Colocar el primer bastidor con su poste.
					let bas = this.cloneEspecial(scheme3d.DTPerimeterActual.mesh, restoPorCiento, scheme3d.DTPerimeterActual.direction, 0, matNeutro, scheme3d);
					bas.position.x = dotX;
					bas.position.y = section.height;			

					scheme3d.DTRootTramo.add(bas);
					

					// Siguiente punto.
					dotX += resto;

					// Colocar poste.
					let _post = scheme3d.gestor.postes.clonePost(scheme3d.DTPerimeterActual.typePost, 'SubPoste' + scheme3d.DTNamePerTramo + scheme3d.DTCountPost++,
						dotX, alturaPoste, scheme3d.DTPerimeterActual.direction);
					if (_post) {
						// Pintar poste.
						if (scheme3d.DTHasColor) scheme3d.paintPost(_post);

						scheme3d.DTRootTramo.add(_post);
					}

					// Colcoar placa base.
					if (scheme3d.DTPerimeterActual.basePlaque) scheme3d.setPlacaBase(_post.position.x, section.height);

					// Resto el primer bastidor.
					unidades--;
				}
			}

			// Colocar los bastidores y postes de relleno.
			for (let i = 0; i < unidades; i++) {
				// Colocar el primer bastidor con su poste.;
				let bas = bastidor.mesh.clone();
				if (scheme3d.DTHasColor) this.paintBastidor(bas, scheme3d);

				// Dirección del perímetro.
				bas.scale.z = scheme3d.DTPerimeterActual.direction;

				bas.position.x = dotX;
				bas.position.y = section.height;

				scheme3d.DTRootTramo.add(bas);
				// Siguiente punto.
				dotX += bastidor.length;

				// Colocar poste.
				let _post = scheme3d.gestor.postes.clonePost(scheme3d.DTPerimeterActual.typePost, 'SubPoste' + scheme3d.DTNamePerTramo + scheme3d.DTCountPost++, dotX, alturaPoste, scheme3d.DTPerimeterActual.direction);
				if (_post) {
					// Pintar poste.
					if (scheme3d.DTHasColor) scheme3d.paintPost(_post);

					scheme3d.DTRootTramo.add(_post);
				}

				// Colcoar placa base.
				if (scheme3d.DTPerimeterActual.basePlaque) scheme3d.setPlacaBase(_post.position.x, section.height);
			}

			// Último bastidor.
			if (resto > 0) {
				// Colocar el primer bastidor con su poste.
				let bas = this.cloneEspecial(scheme3d.DTPerimeterActual.mesh, restoPorCiento, scheme3d.DTPerimeterActual.direction, 0, matNeutro, scheme3d);
				bas.position.x = dotX;
				bas.position.y = section.height;
				scheme3d.DTRootTramo.add(bas);

				// Siguiente punto.
				dotX += resto;
			}
		}
		//  ###################################################### Un solo bastidor cortado.
		// Si la magnitud es más pequeña que el corte, solo se coloca un bastidor ajustado.
		else if (ancho < bastidor.length) {

			//c onsole.log('Si la magnitud es más pequeña que el corte, solo se coloca un bastidor ajustado.');
			let bas = this.cloneEspecial(scheme3d.DTPerimeterActual.mesh, ancho / bastidor.length, scheme3d.DTPerimeterActual.direction, 0, matNeutro, scheme3d);
			bas.position.x = dotX;
			bas.position.y = section.height;
			scheme3d.DTRootTramo.add(bas);
		}
		//  ###################################################### Un solo bastidor sin cortar.
		// Tener en cuenta que la magnitud es igual al corte, baja posibilidad pero puede ocurrir.
		else { // magnitud == data.length
			// En este caso solo se coloca un bastidor sin ajuste.
			//c onsole.log('Tener en cuenta que la magnitud es igual al corte, baja posibilidad pero puede ocurrir.');

			let bas = bastidor.mesh.clone();
			bas.position.x = dotX;
			bas.position.y = section.height;
			scheme3d.DTRootTramo.add(bas);
		}
	}

	public cloneVerjaSimple(type: string) {
		let bastidor = this._data[type];
		if (!bastidor || !bastidor.mesh) return;
		return bastidor.mesh.clone();
	}

	public cloneVerjaMaterials(type: string, colorStyle: string) {
		let verja = this._data[type];
		
		if (!verja) return undefined; // Verja desconocida.

		let objs = { bastidor: undefined, abrazadera: undefined };

		for (let i = 0; i < verja.mesh.children.length; i++) {
			let ch = verja.mesh.children[i];
			if (!objs.bastidor && ch.material.name.startsWith('TRA_')) {
				objs.bastidor = ch.material.clone();
				objs.bastidor.color.setStyle(colorStyle);
			}
			else if (!objs.abrazadera && ch.material.name.startsWith('COL_Abr')) {
				objs.abrazadera = ch.material.clone();
				objs.abrazadera.color.setStyle(colorStyle);
			}
		}

		return objs;
	}

	//#######################################################################################################################################
	public paintBastidor(bastidor: any, scheme3d: Scheme3dComponent) {
		for (let bas of bastidor.children) {
			if (bas.isMesh) {
				if (bas.material.name == 'COL_Neutro') {
					bas.material = scheme3d.gestor.ColorNeutro;
				}
				else if (bas.material.name.startsWith('TRA_')) {
					bas.material = scheme3d.DTCacheMaterials.COL_Bastidor;
				}
				else if (bas.material.name.startsWith('COL_Abraz')) {
					if (scheme3d.DTCacheMaterials.COL_Abrazadera) bas.material = scheme3d.DTCacheMaterials.COL_Abrazadera;
				}
			}
		}
	}

	public paintBastidor2(bastidor: any, colorNeutro: THREE.MeshPhongMaterial, color: THREE.MeshPhongMaterial, colorAbrazadera: THREE.MeshPhongMaterial) {
		for (let bas of bastidor.children) {
			if (bas.isMesh) {
				if (bas.material.name == 'COL_Neutro') {
					bas.material = colorNeutro;
				}
				else if (bas.material.name.startsWith('TRA_')) {
					bas.material = color;
				}
				else if (bas.material.name.startsWith('COL_Abraz')) {
					if (colorAbrazadera) bas.material = colorAbrazadera;
				}
			}
		}
	}

	// Clona un bastidor pero perzonalizado en longitud.
	// Consume más recursos ya que crea una nueva mesh, material y texture.
	// Usar solo para casos especiales como cortar un bastidor fijo (Verjas) o estirar malla (Cercados).
	public cloneEspecial(type: string, length: number, direction: number, objLength: number, color: THREE.MeshPhongMaterial, scheme3d: Scheme3dComponent) {

		//console.log(type);

		if (!type || !length) return undefined;

		// Adquirir el bastidor.
		let obj = this._data[type];

		//console.log(obj);

		if (!obj || !obj.mesh) return undefined;

		// Clonar.
		let bastidor = obj.mesh.clone();

		if (objLength === 0) objLength = obj.length;

		let length2 = (length * (objLength / 100)) * 100;

		let uv2 = (length * (obj.uv / 100)) * 100;
		let corte = -(objLength - length2);

		// Ajuste del bastidor interno para CLASSIC y NOVE. de poste REDONDO
		if(!obj.archivo.includes('CUADRADO')) {
			if (type.startsWith('CLASSIC') || type.startsWith('NOVE')) length2 -= 0.106;
		}

		for (let child of bastidor.children) {
			if (child.isMesh) {
				if (child.name.startsWith('bastidor')) {

					
					child.geometry = child.geometry.clone();
					let material = child.material.clone();
					material.map = Object.assign(child.material.map);
					child.material = material;

					// Escalar bastidor.
					let pos = child.geometry.attributes.position.array;
					for (let u = 0; u < pos.length; u += 3) { if (pos[u] > 0.12) pos[u] = length2; }

					let uvs = child.geometry.attributes.uv.array;

					let max = -1;
					for(let u = 0; u < uvs.length; u += 2){
						if(u==0){
							max = uvs[u];
						} else {
							if(uvs[u] > max){
								max = uvs[u];
							}
						}
					}
					for (let u = 0; u < uvs.length; u += 2) { 
						if(uvs[u] >= max){
							uvs[u] = uv2;
						}
					}

					/*
					for (let u = 0; u < uvs.length; u += 2) { 
						console.log(uvs[u])
						//if (uvs[u] > 0.09) uvs[u] = uv2;
					
					}
					*/

					child.geometry.verticesNeedUpdate = true;
					child.geometry.elementsNeedUpdate = true;
					child.geometry.uvsNeedUpdate = true

					child.scale.z = direction;
					
				}
				else if (child.name.startsWith('corte')) { child.position.x = corte; }
				else if (child.name.startsWith('barra')) { child.scale.x = length; }

				if (scheme3d !== undefined) {
					if (scheme3d.DTHasColor) {
						if (child.material.name == 'COL_Neutro') {
							child.material = color;
						}
						else if (child.material.name.startsWith('TRA_')) {
							child.material.color.set(scheme3d.gestor.ColorNeutro.color);
						}
						else if (child.material.name.startsWith('COL_Abraz')) {
							if (scheme3d.DTCacheMaterials.COL_Abrazadera) child.material = scheme3d.DTCacheMaterials.COL_Abrazadera;
						}
					}
				}
			}
		}
		return bastidor;
	}

	// Clona una malla que desde A a B teniendo en cuenta la altura.
	public cloneEspecialLUX(type: string, pointA: THREE.Vector3, pointB: THREE.Vector3,
		direction: number, color: THREE.MeshPhongMaterial, hasColor: boolean,
		colorNeutro: THREE.MeshPhongMaterial, matAbrazadera: THREE.MeshPhongMaterial) {

		let length = pointA.distanceTo(pointB);

		// Adquirir el malla.
		let obj = this._data[type];
		if (!obj || !obj.mesh) return undefined;

		// Clonar.
		let malla = obj.mesh.clone();
		let objLength = 1;

		let length2 = (length * (objLength / 100)) * 100;

		let uv2 = (length * (obj.uv / 100)) * 100;
		let corte = -(objLength - length2);

		// Ajuste del bastidor interno para CLASSIC y NOVE.
		if (type.startsWith('CLASSIC') || type.startsWith('NOVE')) length2 -= 0.106;
		for (let child of malla.children) {
			if (child.isMesh) {
				if (child.name.startsWith('bastidor')) {
					child.geometry = child.geometry.clone();
					let material = child.material.clone();
					material.map = Object.assign(child.material.map);
					child.material = material;

					// Escalar bastidor.
					let pos = child.geometry.attributes.position.array;
					let salto = pointB.y - pointA.y;
					for (let u = 0; u < pos.length; u += 3) {
						if (pos[u] > 0.12) {
							pos[u] = length2;
							pos[u + 1] += salto;
						}
					}

					let uvs = child.geometry.attributes.uv.array;
					for (let u = 0; u < uvs.length; u += 2) { if (uvs[u] > 0.09) uvs[u] = uv2; }

					child.geometry.verticesNeedUpdate = true;
					child.geometry.elementsNeedUpdate = true;
					child.geometry.uvsNeedUpdate = true

					child.scale.z = direction;
				}
				else if (child.name.startsWith('corte')) { child.position.x = corte; }
				else if (child.name.startsWith('barra')) { child.scale.x = length; }

				if (hasColor) {
					if (child.material.name == 'COL_Neutro') {
						child.material = color;
					}
					else if (child.material.name.startsWith('TRA_')) {
						child.material.color.set(colorNeutro.color);
					}
					else if (child.material.name.startsWith('COL_Abraz')) {
						if (matAbrazadera) child.material = matAbrazadera;
					}
				}
			}
		}
		return malla;
	}

	// Colocar el bastidor entero.
	private cloneAllAnudada(bastidor: any, x: number, height: number, direction: number) {
		let bas = bastidor.mesh.clone();
		bas.position.x = x;
		bas.position.y = height;
		bas.scale.z = direction;
		return bas;
	}

	public cloneEspecialAnudadaXYZ(type: any, pointA: THREE.Vector3, pointB: THREE.Vector3, length: number, height: number, direction: number) {
		if (!type || !length) return undefined;

		// Adquirir el bastidor.
		let bastidor = this._data[type];
		if (!bastidor || !bastidor.mesh) return undefined;

		// Clonar.
		let bas = bastidor.mesh.clone();
		let uv2 = (length * (bastidor.uv / 100)) * 100;

		let child = bas.children[0];
		if (child.isMesh) {
			child.geometry = child.geometry.clone();
			let material = child.material.clone();
			material.map = Object.assign(child.material.map);
			child.material = material;

			// Escalar bastidor.
			let pos = child.geometry.attributes.position.array;
			let salto = pointB.y - pointA.y;
			for (let u = 0; u < pos.length; u += 3) {
				if (pos[u] > 0.12) {
					pos[u] = length;
					pos[u + 1] += salto;
				}
			}

			let uvs = child.geometry.attributes.uv.array;
			for (let u = 0; u < uvs.length; u += 2) { if (uvs[u] > 0.09) uvs[u] = uv2; }

			child.geometry.verticesNeedUpdate = true;
			child.geometry.elementsNeedUpdate = true;
			child.geometry.uvsNeedUpdate = true
		}
		bas.position.set(pointA.x, pointA.y + height, pointA.z);
		bas.scale.z = direction;
		return bas;
	}

	public cloneEspecialAnudada(bastidor: any, x: number, height: number, length: number, direction = 1) {
		// Clonar.
		let bas = bastidor.mesh.clone();

		let uv2 = (length * (bastidor.uv / 100)) * 100;

		let child = bas.children[0];
		if (child.isMesh) {
			child.geometry = child.geometry.clone();
			let material = child.material.clone();
			material.map = Object.assign(child.material.map);
			child.material = material;

			// Escalar bastidor.
			let pos = child.geometry.attributes.position.array;
			for (let u = 0; u < pos.length; u += 3) { if (pos[u] > 0.12) pos[u] = length; }

			let uvs = child.geometry.attributes.uv.array;
			for (let u = 0; u < uvs.length; u += 2) { if (uvs[u] > 0.09) uvs[u] = uv2; }

			child.geometry.verticesNeedUpdate = true;
			child.geometry.elementsNeedUpdate = true;
			child.geometry.uvsNeedUpdate = true

			child.position.x = x;
			child.position.y = height;
			child.scale.z = direction;
		}

		return bas;
	}

}